import { QUERY_KEY } from 'constants/globalConstants'
import UserService from 'apiService/permissions'
import { useQuery } from 'react-query'

const useGetGroupWisePermission = () => {
    return useQuery(QUERY_KEY.GET_GROUP_WISE_PERMISSION, UserService.getGroupWisePermission, {retry: false})
}

export default useGetGroupWisePermission